import { Grid, Typography } from '@uikit';
import { useMemo } from 'react';
import classes from './footer.module.scss';

export const Footer = () => {
  const year = useMemo(() => new Date().getFullYear(), []);
  return (
    <footer className={classes.footer}>
      <Grid.Container>
        <Grid.Column className={classes.footer_container}>
          <Typography color="gray" className={classes.footer_content}>
            &copy; {year} ABN AMRO
          </Typography>
        </Grid.Column>
      </Grid.Container>
    </footer>
  );
};
